// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresCustomGridAddBody = {
  poolId: string;
  title?: string | null;
  topLabel: string;
  sideLabel: string;
  doPublishNow: boolean;
  doNotifyMembers: boolean;
  transactionId: string;
};

export type typeSquaresCustomGridAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    status: "created" | "existing";
    gridId: string;
    eventId: string;
    title: string;
  };
};

export type typeSquaresCustomGridAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresCustomGridAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresCustomGridAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresCustomGridAddBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    title: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    topLabel: { type: "string", maxLength: 3000, minLength: 1 },
    sideLabel: { type: "string", maxLength: 3000, minLength: 1 },
    doPublishNow: { type: "boolean" },
    doNotifyMembers: { type: "boolean" },
    transactionId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: [
    "poolId",
    "topLabel",
    "sideLabel",
    "doPublishNow",
    "doNotifyMembers",
    "transactionId",
  ],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresCustomGridAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresCustomGridAddBody);
  }

  return async function postSquaresCustomGridAdd(
    payload: typeSquaresCustomGridAddBody,
  ): Promise<
    typeSquaresCustomGridAddOutput200 | typeSquaresCustomGridAddOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresCustomGridAdd" failed before calling the network. #3e917aaf1e63`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3e917aaf1e63" },
        },
        data: null,
      } as typeSquaresCustomGridAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/custom-grid-add`,
      httpMethod: "POST",
      options,
    })) as
      typeSquaresCustomGridAddOutput200 | typeSquaresCustomGridAddOutput400;
  };
}
